import { BOOKING_EXPIRED, BOOKING_RESET, FETCH_ORDER_DETAILS, REMOVE_ITEM_FROM_CART } from "./actions";
import { OrderDetails } from "./types";

export const initialOrderDetailsState: OrderDetails = null;

export function orderDetailsReducer(
    state = initialOrderDetailsState,
    action: any
): OrderDetails {
    switch (action.type) {
        case FETCH_ORDER_DETAILS: {
            if (action.payload.isExpired) {
                return initialOrderDetailsState;
            }

            return action.payload;
        }
        case BOOKING_EXPIRED: {
            return initialOrderDetailsState;
        }
        case REMOVE_ITEM_FROM_CART: {
            // in case all items were removed from cart reset to initial
            if (action.payload.totalQtyInCart <= 0) {
                return initialOrderDetailsState;
            }

            return state;
        }
        case BOOKING_RESET: {
            return initialOrderDetailsState;
        }
        default:
            return state
    }
}
